import React, {Component} from 'react'
import {Checkbox, Col, Form, message, Modal, Row, Spin, TimePicker,Select} from 'antd';
import moment from 'moment';
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";

const FORMAT = 'HH:mm';
class OrderSubSetModal extends Component{
    state={
        loading: false,
        visible: false,
        orderNo:null,
        orderId:null,
        orderInfo:{},
        subInfo:{},
        customTimeFlag:false,
        startTime:null,
        endTime:null,
        allOrderFlag:false,
        configType:"orderNo",
        nodeList:[],
        changed:false,
    }
    init = ()=>{
        this.setState({
            orderInfo:{},
            subInfo:{},
            startTime:null,
            endTime:null,
            customTimeFlag:false,
            allOrderFlag:false,
            nodeList:[],
            configType:"orderNo",
            changed:false,
        })
    }
    onChange = (e,key) => {
        this.setState({
            changed:true,
            [key]: e.target.checked,
        });
    };
    hide=()=>{
        this.setState({
            visible:false
        },()=>{
            this.props.updateVisible(false)
        })
    }
    handleOk=()=>{
        this.save()
    }
    handleCancel=()=>{
        this.hide()
    }
    getRouteInfo=(routeCode)=>{
        this.setState({
            loading:true,
        })
        let params ={code: routeCode}
        let result = ajax(baseUrl+'/api/v1/p/routeNodes',params);
        result.then((resp)=>{
            if(resp.code === 200){
                let arr = resp.data

                arr.forEach((item)=>{
                    if(this.state.subInfo.excludeNodes && this.state.subInfo.excludeNodes.includes(item.nodeCode)){
                        item.checked=false
                    }else{
                        item.checked = true
                    }
                })
                this.setState(({
                    nodeList:arr
                }))

            }else{
                this.setState({

                })
            }
        }).catch(()=>{
            this.setState({

            })
        }).finally(()=>{
            this.setState({

            })
        })
    }
    getSubInfo=(orderNo,configType="orderNo")=>{
        this.setState({
            loading:true,
            subInfo:{}
        })
        let params ={orderNo: orderNo,configType:configType}
        let result = ajax(baseUrl+'/api/v1/p/routeConfig',params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    subInfo:resp.data,
                    customTimeFlag:resp.data.startTime?true:false,
                    startTime:resp.data.startTime?moment(resp.data.startTime, FORMAT):null,
                    endTime:resp.data.endTime?moment(resp.data.endTime, FORMAT):null,
                    allOrderFlag:resp.data.allFlag ==="Y",
                })
                this.getRouteInfo(resp.data.routeCode)
                this.props.form.setFieldsValue({startTime: this.state.startTime, endTime: this.state.endTime});
            }else{
                this.setState({
                    subInfo:{}
                })
            }
        }).catch(()=>{
            this.setState({
                subInfo:{}
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    getOrderInfo=(orderId,configType="orderNo")=>{
        this.init()
        this.setState({
            loading:true,
            orderInfo:{},
            configType:configType,
        })
        let params ={id: orderId}
        let result = ajax(baseUrl+'/api/v1/p/oms/order',params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    orderInfo:resp.data
                })
                this.getSubInfo(resp.data.orderNo,configType)
            }else{
                this.setState({
                    orderInfo:{}
                })
            }
        }).catch(()=>{
            this.setState({
                orderInfo:{}
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    save = ()=>{
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    loading:true,
                })
                let params = {
                    "orderNo": this.state.orderInfo.orderNo,
                    "routeCode": this.state.subInfo.routeCode,
                    "allFlag": this.state.configType==='route'?"Y":"N"
                }
                params.excludeNodes = []
                if(this.state.nodeList){
                    this.state.nodeList.forEach((item)=>{
                        if(!item.checked){
                            params.excludeNodes.push(item.nodeCode)
                        }
                    })
                }
                if(this.state.customTimeFlag){
                    if(this.state.startTime){
                        params.startTime = this.state.startTime.format(FORMAT)
                    }
                    if(this.state.endTime){
                        params.endTime = this.state.endTime.format(FORMAT)
                    }
                }else {
                    // params.startTime=""
                    // params.endTime=""
                }
                let result = ajax(baseUrl+'/api/v1/p/routeConfig',params,"PUT");
                result.then((resp)=>{
                    if(resp.code === 200){
                        this.setState({
                            changed:false,
                        })
                        message.info("更新成功")
                        this.getOrderInfo(this.state.orderId,this.state.configType)
                    }else{
                        message.error(resp.message)
                    }
                }).catch(()=>{
                    this.setState({

                    })
                }).finally(()=>{
                    this.setState({
                        loading:false
                    })
                })
            }
        });
    }
    timeOnChange = (key,moment)=>{
        this.setState({
            [key]:moment,
            changed:true,
        })
    }
    nodeCheckedChange=(nodeCode)=>{
        let newArr = this.state.nodeList
        for(let i=0;i<newArr.length;i++){
            if(newArr[i].nodeCode===nodeCode){
                newArr[i].checked = !newArr[i].checked
                break
            }
        }
        this.setState({
            nodeList:newArr,
            changed:true,
        })
    }
    validateTime = (rule, value, callback) => {
        const { form } = this.props;
        if (this.state.customTimeFlag && !value) {
            callback('时间不能为空!');
        } else {
            callback();
        }
    };
    validateEndTime = (rule, value, callback) => {
        const { form } = this.props;
        if (this.state.customTimeFlag && value &&this.state.startTime && value<=this.state.startTime) {
            callback('结束时间必须晚于开始时间!');
        } else {
            callback();
        }
    };
    validateStartTime = (rule, value, callback) => {
        const { form } = this.props;
        if (this.state.customTimeFlag && value && this.state.endTime && value>this.state.endTime) {
            callback('开始时间必须早于结束时间!');
        } else {
            callback();
        }
    };
    componentWillReceiveProps(nextProps) {
        if(nextProps.orderId!=this.state.orderId) {
            this.setState({
                orderId: nextProps.orderId
            })
        }
        if(nextProps.visible!=this.state.visible) {
            this.setState({
                visible: nextProps.visible
            },()=>{
                if(this.state.visible ){
                    this.getOrderInfo(nextProps.orderId)
                }
            })
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;

        return(
            <div>
                <Modal
                    title="告警设置"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={"60%"}
                    okText ={"保存"}
                >
                    <Spin size="large" spinning={this.state.loading}>
                        <div style={{padding:10}}>
                            <Form layout="inline" >
                            <div className='box-shadow padding-20'>
                                    <Row>
                                        <Col span={6}>
                                            <Select value={this.state.configType} getPopupContainer={triggerNode => triggerNode.parentNode} onChange={(value)=>{
                                                if(this.state.changed) {
                                                    Modal.confirm({
                                                        title: '修改未保存，是否继续？',
                                                        onOk: () => {
                                                            this.setState({
                                                                configType: value
                                                            })
                                                            this.getOrderInfo(this.state.orderId, value)
                                                        },
                                                        onCancel: () => {
                                                            this.setState((prevState) => {
                                                                return {configType: prevState.configType}
                                                            })
                                                        }
                                                    });
                                                }else{
                                                    this.setState({
                                                        configType: value
                                                    })
                                                    this.getOrderInfo(this.state.orderId, value)
                                                }
                                            }}>
                                                <Select.Option value={"orderNo"}>仅适用于本订单</Select.Option>
                                                <Select.Option value={"route"}>适用于该线路的所有订单</Select.Option>
                                            </Select>
                                        </Col>
                                    </Row>
                                </div>
                            <div className='box-shadow padding-20'>
                                <div>告警线路:</div>
                                {this.state.orderInfo.originCity} --> {this.state.orderInfo.destinationCity}
                                <div>
                                        <Row>
                                            {this.state.nodeList.map((item,key)=>(
                                                <Col span={8} key={`col-${key}`}>
                                                    <Checkbox style={{minWidth:100}} onChange={()=>{this.nodeCheckedChange(item.nodeCode)}} defaultChecked={item.checked} value={item.nodeCode}>{item.nodeName}</Checkbox>
                                                </Col>
                                            ))}
                                        </Row>
                                </div>
                            </div>
                            <br/>
                            <div className='box-shadow padding-20'>
                                <div>
                                    <Form.Item label="">
                                        {getFieldDecorator('customTimeFlag', {
                                            rules: [],
                                        })(
                                            <Checkbox checked={this.state.customTimeFlag} onChange={(e)=>{this.onChange(e,"customTimeFlag")}}>自定义告警时段</Checkbox>
                                        )}
                                        </Form.Item>
                                </div>
                                <div>
                                    <Form.Item label="从">
                                        {getFieldDecorator('startTime', {
                                            initialValue:this.state.startTime,
                                            rules: [{validator: this.validateTime},,{validator: this.validateStartTime}],
                                        })(<TimePicker disabled={!this.state.customTimeFlag}  format={FORMAT} minuteStep={5} onChange={(moment)=>{this.timeOnChange("startTime",moment)}}/>
                                        )}
                                    </Form.Item>
                                    <Form.Item label="至">
                                        {getFieldDecorator('endTime', {
                                            initialValue:this.state.endTime,
                                            rules: [{validator: this.validateTime},{validator: this.validateEndTime}],
                                        })(<TimePicker disabled={!this.state.customTimeFlag} format={FORMAT} minuteStep={5} onChange={(moment)=>{this.timeOnChange("endTime",moment)}}/>
                                        )}
                                    </Form.Item>
                                </div>
                            </div>
                            {/*<br/>*/}
                            {/*<div className='box-shadow padding-20'>*/}
                            {/*    <div><Checkbox checked={this.state.allOrderFlag} onChange={(e)=>{this.onChange(e,"allOrderFlag")}}>应用于所有（{this.state.orderInfo.originCity} --> {this.state.orderInfo.destinationCity}）订单</Checkbox> </div>*/}
                            {/*</div>*/}
                            </Form>
                        </div>
                    </Spin>
                </Modal>
            </div>
        )
    }
}
const OrderSubSetModalForm = Form.create()(OrderSubSetModal)
export default OrderSubSetModalForm